<script>
import { Doughnut } from 'vue-chartjs'
import Chart from 'chart.js'

let centerPluginRegistered = false

export default {
  extends: Doughnut,
  props: {
    chartdata: {
      type: Object,
      default: null
    },
    options: {
      type: Object,
      default: null
    },
    centerText: {
      type: [String, Number],
      default: ''
    },
    showDataLabels: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    chartdata: {
      deep: true,
      handler(newData) {
        this.renderChart(newData, this.getOptions())
      }
    },
    options: {
      deep: true,
      handler() {
        this.renderChart(this.chartdata, this.getOptions())
      }
    },
    centerText() {
      this.renderChart(this.chartdata, this.getOptions())
    },
    showDataLabels() {
      this.renderChart(this.chartdata, this.getOptions())
    }
  },
  mounted () {
    this.registerCenterPlugin()
    this.renderChart(this.chartdata, this.getOptions())
  },
  methods: {
    getOptions() {
      const baseOptions = this.options || {}
      const elements = baseOptions.elements || {}
      const center = elements.center || {}
      const plugins = baseOptions.plugins || {}
      const datalabels = plugins.datalabels || {}

      return {
        ...baseOptions,
        elements: {
          ...elements,
          center: {
            ...center,
            text: this.centerText !== '' ? String(this.centerText) : center.text
          }
        },
        plugins: {
          ...plugins,
          datalabels: {
            ...datalabels,
            display: (context) => {
              if (!this.showDataLabels) return false
              const value = context.dataset.data[context.dataIndex]
              return !(value === 0 || value === '0' || value === null || value === undefined)
            }
          }
        }
      }
    },
    registerCenterPlugin() {
      if (centerPluginRegistered) {
        return
      }

      Chart.pluginService.register({
        beforeDraw: function(chart) {
          if (chart.config.type !== 'doughnut') {
            return
          }

          const centerOptions = chart.config.options && chart.config.options.elements && chart.config.options.elements.center
          if (!centerOptions || !centerOptions.text) {
            return
          }

          const width = chart.chart.width
          const height = chart.chart.height
          const ctx = chart.chart.ctx
          const text = centerOptions.text
          const fontSize = (height / 50).toFixed(2)

          ctx.restore()
          ctx.font = fontSize + 'em sans-serif'
          ctx.fillStyle = centerOptions.color || '#2D4B95'
          ctx.textBaseline = 'middle'

          const textX = Math.round((width - ctx.measureText(text).width) / 2)
          const textY = height / 1.8

          ctx.fillText(text, textX, textY)
          ctx.save()
        }
      })

      centerPluginRegistered = true
    }
  }
}
</script>
